/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{color:#525252;text-align:center;font-family:Montserrat;font-size:22px;font-style:normal;font-weight:600;line-height:normal}.subtitle[_ngcontent-%COMP%]{color:#525252;text-align:center;font-family:Montserrat;font-size:16px;font-style:normal;font-weight:600;line-height:normal}.button-close[_ngcontent-%COMP%]{width:100%;height:50px;border-radius:5px;background-color:#1f2c5b;color:#fff;border:#1f2c5b}"];
export { styles as styles };
